import api from "./axiosInstance";
import { getCurrentCompanyConfig } from "../config/companies";

interface APIResponse<T> {
    success: boolean;
    data?: T;
    message?: string;
    status?: number;
}

//verify end user applicant details
export const verifyEndUserDetails = async (data: any, config?: any): Promise<APIResponse<any>> => {
    const activeConfig = { ...getCurrentCompanyConfig(), ...config };
    try {
        const payload = {
            ...data,
            aspAccreditationNumber: activeConfig?.aspAccreditationNumber || import.meta.env.VITE_ASP_ACCREDIATION_NUMBER,
            aspName: activeConfig?.aspName || import.meta.env.VITE_ASP_NAME,
            serviceProviderId: activeConfig?.serviceProviderId || import.meta.env.VITE_SERVICE_PROVIDER_ID,
            smpAccesspointId: activeConfig?.smpAccesspointId || import.meta.env.VITE_SMP_ACCESSPOINT_ID,
        };
        const response = await api.post(`/accreditation/v1/verify`, payload);
        return { success: true, data: response.data };
    } catch (err: any) {
        return { success: false, message: err.response?.data?.message || err.message, status: err.response?.status };
    }
};

//create participant
export const createParticipant = async (data: any, config?: any): Promise<APIResponse<any>> => {
    const activeConfig = { ...getCurrentCompanyConfig(), ...config };
    try {
        const payload = {
            ...data,
            aspAccreditationNumber: activeConfig?.aspAccreditationNumber || import.meta.env.VITE_ASP_ACCREDIATION_NUMBER,
            aspName: activeConfig?.aspName || import.meta.env.VITE_ASP_NAME,
            serviceProviderId: activeConfig?.serviceProviderId || import.meta.env.VITE_SERVICE_PROVIDER_ID,
            smpAccesspointId: activeConfig?.smpAccesspointId || import.meta.env.VITE_SMP_ACCESSPOINT_ID,
        };
        const response = await api.post(`/accreditation/v1/onboarding`, payload);
        return { success: true, data: response.data };
    } catch (err: any) {
        return { success: false, message: err.response?.data?.message || err.message, status: err.response?.status };
    }
};

//re verify end user details
export const reVerifyParticipant = async (data: any, config?: any): Promise<APIResponse<any>> => {
    const activeConfig = { ...getCurrentCompanyConfig(), ...config };
    try {
        const payload = {
            ...data,
            aspAccreditationNumber: activeConfig?.aspAccreditationNumber || import.meta.env.VITE_ASP_ACCREDIATION_NUMBER,
            aspName: activeConfig?.aspName || import.meta.env.VITE_ASP_NAME,
            serviceProviderId: activeConfig?.serviceProviderId || import.meta.env.VITE_SERVICE_PROVIDER_ID,
            smpAccesspointId: activeConfig?.smpAccesspointId || import.meta.env.VITE_SMP_ACCESSPOINT_ID,
        };
        const response = await api.put(`/accreditation/v1/reverify`, payload);
        return { success: true, data: response.data };
    } catch (err: any) {
        return { success: false, message: err.response?.data?.message || err.message, status: err.response?.status };
    }
};

//de link participant
export const delinkParticipant = async (data: any, config?: any): Promise<APIResponse<any>> => {
    const activeConfig = { ...getCurrentCompanyConfig(), ...config };
    try {
        const payload = {
            ...data,
            aspAccreditationNumber: activeConfig?.aspAccreditationNumber || import.meta.env.VITE_ASP_ACCREDIATION_NUMBER,
            aspName: activeConfig?.aspName || import.meta.env.VITE_ASP_NAME,
            serviceProviderId: activeConfig?.serviceProviderId || import.meta.env.VITE_SERVICE_PROVIDER_ID,
            smpAccesspointId: activeConfig?.smpAccesspointId || import.meta.env.VITE_SMP_ACCESSPOINT_ID,
        };
        const response = await api.delete(`/accreditation/v1/offboarding`, { data: payload });
        return { success: true, data: response.data };
    } catch (err: any) {
        return { success: false, message: err.response?.data?.message || err.message, status: err.response?.status };
    }
};